export const USER_PROFILE_TAB_ATTRIBUTES_QA_NAME = 'userProfileTabAttributes'
